import { createReducer } from 'reduxsauce';
import { types } from './actions';

export const INITIAL_STATE = {
  userId: '',
  name: '',
  role: '',
  email: '',
  avatar: '',
  is_admin: [],
  authorized: false,
  // Initial state is `loading: true` so IndexLayout shows <Loader /> on cold
  // load until LOAD_CURRENT_ACCOUNT resolves (saga registry is now lazy-loaded
  // — see configureStore.js bootstrapSaga). Without this gate, an admin user
  // with a valid session would briefly see a redirect to /auth/login before
  // bouncing back to dashboard.
  loading: true,
  employer_programs: [],
  bSuccessSectionVisible: false,
  bErrorSectionVisible: false,
  // savedUserInfo: {
  //   email: "",
  //   password: ""
  // }
};

export default createReducer(INITIAL_STATE, {
  [types.SET_STATE]: (state, { payload }) => ({ ...state, ...payload }),
});
